import Repository from './Repository';

const resource = '/shop';

export default {
  /**
   * Shop詳細
   * @param shopId
   */
  getDetail(shopId: string): Promise<Shop> {
    return Repository.get(`${resource}/${shopId}`);
  },
  getDetails(shopIds: string[] = []): Promise<Shop[]> {
    const params = new URLSearchParams();
    shopIds.forEach((id: string) => params.append('id', id));
    return Repository.get(`${resource}?${params.toString()}`);
  },
};

export type Shop = {
  id: string;
  orgId: string;
  channelId: string;
  name: string;
  attrs: string;
  createdAt: Date['toISOString'];
  updatedAt: Date['toISOString'];
  channel: any;
  __typename: 'Shop';
};
